import type { CareerTierId } from '@crowdfpl/domain/gamification';
import { formatCareerTierLabel } from '@/components/gamification/career-tier-labels';
import type { GamificationMeState, GamificationPublicState } from '@/types/gamification';

export type ProgressState = GamificationMeState['progress'] | GamificationPublicState['progress'];

export function clampSegmentProgress(progress: number): number {
  if (typeof progress !== 'number' || Number.isNaN(progress)) {
    return 0;
  }
  return Math.min(1, Math.max(0, progress));
}

export function isNewManagerProgress(progress: ProgressState): boolean {
  return (
    progress.tier === 'rookie' &&
    progress.is_active_current_season === false &&
    progress.top_percent === null
  );
}

export function isMaxTierProgress(progress: ProgressState): boolean {
  return progress.tier === 'legend' || progress.next_tier === null;
}

export function identityTitle(progress: ProgressState): string {
  return formatCareerTierLabel(progress.tier);
}

export function nextTierCopy(progress: ProgressState): string {
  if (isMaxTierProgress(progress)) {
    return 'Max tier';
  }
  if (progress.next_tier == null || progress.xp_to_next == null) {
    return 'Max tier';
  }
  return `${progress.xp_to_next.toLocaleString()} to ${formatCareerTierLabel(progress.next_tier)}`;
}

export function identityAccentClass(tier: CareerTierId): string {
  if (tier === 'legend') {
    return 'text-gold';
  }
  if (tier === 'mastermind') {
    return 'text-career-mastermind';
  }
  return 'text-primary';
}

export function identityIconSurfaceClass(tier: CareerTierId): string {
  if (tier === 'legend') {
    return 'border-gold bg-gold/10 text-gold';
  }
  if (tier === 'mastermind') {
    return 'border-career-mastermind bg-career-mastermind/10 text-career-mastermind';
  }
  return 'border-primary bg-primary/10 text-primary';
}

export function identityStrokeClass(tier: CareerTierId): string {
  if (tier === 'legend') {
    return 'stroke-gold';
  }
  if (tier === 'mastermind') {
    return 'stroke-career-mastermind';
  }
  return 'stroke-primary';
}
